<nb-chat #chatComponent  [ngClass]="maximized ? 'chat-expand' : 'chat-collapse'" size="large" style="position:fixed;bottom: 0; right:0.5rem;z-index: 99999" [scrollBottom]="true" *ngIf="!close">
    <ng-template nbChatTitle>
        <div class="flex-space-between">
            <div>
                <nb-user
                    size="medium"
                    name="Billy"
                    title="{{labelAsistente}}"
                    [picture]="logoBilly"
                >
                </nb-user>
            </div>
        </div>
    </ng-template>

    <a *nbCustomMessage="'link'; let data" [href]="data.href" target="_blank">
        {{ data.text }}
    </a>

    <div *nbCustomMessage="'button'; let buttonText">
        <p (click)="selectOption(buttonText)" class="text-control button-custom-message-text">{{ buttonText }}</p>
    </div>
    <div *nbCustomMessage="'list'; let buttonList">
        <p class="txt-custom-message-list">{{labelSeleccioneUno}}</p>
        <p class="button-custom-message-list" (click)="selectOption('1')">1. {{textoCutomMensaje1}}</p>
        <p class="button-custom-message-list" (click)="selectOption('2')">2. {{textoCutomMensaje2}}</p>
        <p class="button-custom-message-list" (click)="selectOption('3')">3. {{textoCutomMensaje3}}</p>
    </div>
    <div *ngIf="selectedOption">
        <div *nbCustomMessage="'list2'; let buttonList" style="display:inline-flex;">
            <p class="button-custom2-message-list" style="margin-right: 1rem;" (click)="selectOptionBoolean('si')">{{labelSi}}</p>
            <p class="button-custom2-message-list" (click)="selectOptionBoolean('no')">{{labelNo}}</p>
        </div>
    </div>


    <nb-chat-message
        *ngFor="let msg of messages"
        [type]="msg.type"
        [message]="msg.text"
        [reply]="msg.reply"
        [sender]="msg.user.name"
        [date]="msg.date"
        [avatar]="msg.user.avatar"
        [customMessageData]="msg.customMessageData"
    >
    </nb-chat-message>


    <nb-chat-form (send)="sendMessage($event)" [dropFiles]="false" messagePlaceholder="{{labelEscribir}}">
    </nb-chat-form>

</nb-chat>
